import {
  Box,
  Button,
  Divider,
  IconButton,
  InputAdornment,
  MenuItem,
  Pagination,
  Popover,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  Grid,
  FormControl,
  Select,
  InputLabel
} from '@mui/material';
import { SELECT_BACKGROUND_COLOR, TABLE_HEADER_BACKGROUND_COLOR, TEXT_TITLE_COLOR } from '../../constants/colors';
import Avatar from '@mui/material/Avatar';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import FormBranchManage from './form';
import TableSearchNotFound from '../../components/tableSearchNotFound';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ConfirmDialog from '../../components/ConfirmDialog';
import TabPanelActiveComponent from './components/TabPanel';
import LinearProgress from '@mui/material/LinearProgress';
import { IMAGE_MERCHANT_URL } from '../../lib/endpoints/merchant';
import { MerchantEnum } from '../../enums/merchantEnum';
import { useTranslation } from 'react-i18next';
import { EN_ACCEPT_LANGUAGE } from '../../constants/acceptLanguageApi';
import LoadingAnimatedIcon from '../../components/loading/loadingAnimated';
import StatusChip from '../../components/StatusChip';
import { useBranchManageControllers } from './controller/index';

const BranchManageView = () => {
  const controllers = useBranchManageControllers();
  const { t, i18n } = useTranslation("global");

  return (
    <>
      {controllers.openForm ? (
        <FormBranchManage
          onClose={controllers.handleCloseForm}
          onfetch={controllers.handleFetchMerChant}
          selectedMerchant={controllers.selectedMerchant}
          selectMerchant={controllers.selectMerchant}
          merchantType={controllers.merchantType}
        />
      ) : (
        <Box>
          {
            controllers.loadingData ?
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <LoadingAnimatedIcon />
              </Box> : <>
                <Box sx={{ display: 'flex', gap: 1, justifyContent: 'space-between' }}>
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 2, width: '100%' }}>
                    <Typography variant="h4" fontWeight="bold" color={TEXT_TITLE_COLOR}>
                      {t("branchManage_page.Branch Manage")}
                    </Typography>
                    <Box sx={{ ml: 1 }}>
                      <TextField
                        placeholder={`${t("branchManage_page.Enter branch name")}`}
                        value={controllers.searchValue}
                        onChange={controllers.handleSearchValue}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon />
                            </InputAdornment>
                          ),
                        }}
                        size="small"
                      />
                    </Box>
                    <Box sx={{ width: 200 }}>
                      <FormControl fullWidth size='small'>
                        <InputLabel id="merchant-label-id">{t("Merchant")}</InputLabel>
                        <Select
                          labelId="merchant-label-id"
                          id="merchant-id"
                          label="Merchant"
                          value={controllers.merchantType}
                          onChange={controllers.handleSelectedBranch}
                          sx={{ bgcolor: SELECT_BACKGROUND_COLOR, '.MuiOutlinedInput-notchedOutline': { border: 0 }, borderRadius: '8px' }}
                        >
                          {
                            Object.values(MerchantEnum).map((type: MerchantEnum) => (
                              <MenuItem key={type} value={type}>
                                {type}
                              </MenuItem>
                            ))
                          }
                        </Select>
                      </FormControl>
                    </Box>
                  </Box>
                </Box>
                <Box sx={{ mt: 4, display: 'flex' }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={4}>
                      <Box sx={{
                        background: '#C7EBFF',
                        p: 4,
                        borderRadius: '10px',
                      }}>
                        <Typography sx={{ mb: 1 }}>{t("branchManage_page.All branch")}</Typography>
                        <Typography fontWeight='bold' variant="h5">{controllers.countMerchant} {t("Merchant")}</Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <Box sx={{
                        background: '#C1FEC6',
                        p: 4,
                        borderRadius: '10px',
                      }}>
                        <Typography sx={{ mb: 1 }}>{t("branchManage_page.Active branch")}</Typography>
                        <Typography fontWeight='bold' variant="h5">{controllers.filterActive.length} {t("Merchant")}</Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <Box sx={{
                        background: '#FFACB6',
                        p: 4,
                        borderRadius: '10px',
                      }}>
                        <Typography sx={{ mb: 1 }}>{t("branchManage_page.InActive branch")}</Typography>
                        <Typography fontWeight='bold' variant="h5">{controllers.filterInActive.length} {t("Merchant")}</Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'end', mt: 2, mb: 2 }}>
                  {/* <Button variant="contained" sx={{ textTransform: 'none', borderRadius: '10px' }}>
              <AddIcon />
              &nbsp; import branch by csv
            </Button> */}
                  <Button
                    variant="contained"
                    sx={{ textTransform: 'none', borderRadius: '10px', ml: 2, background: '#11A2F1' }}
                    onClick={controllers.handleOpenForm}
                  >
                    <AddIcon />
                    &nbsp; {t("branchManage_page.Create Branch")}
                  </Button>
                </Box>
                <Box
                  sx={{ mb: 2, mt: 2, background: '#F4F6F8', borderBottom: 1, borderColor: 'divider' }}
                >
                  <TabPanelActiveComponent value={controllers.tabStatus} onChange={controllers.handleSetTabStatus} />
                </Box>
                <Box>
                  <TableContainer>
                    <Table>
                      <TableHead sx={{ background: TABLE_HEADER_BACKGROUND_COLOR }}>
                        <TableRow>
                          <TableCell sx={{ borderBottom: 'none' }}>{t("branchManage_page.No")}</TableCell>
                          <TableCell sx={{ borderBottom: 'none' }}>{t("branchManage_page.Image")}</TableCell>
                          <TableCell sx={{ borderBottom: 'none' }}>{t("branchManage_page.Branch name")}</TableCell>
                          <TableCell align='center' sx={{ borderBottom: 'none' }}>{t("branchManage_page.Merchant No")}</TableCell>
                          <TableCell sx={{ borderBottom: 'none' }}>{t("branchManage_page.Village")}</TableCell>
                          <TableCell sx={{ borderBottom: 'none' }}>{t("branchManage_page.Province")}</TableCell>
                          <TableCell sx={{ borderBottom: 'none' }}>{t("branchManage_page.Company")}</TableCell>
                          <TableCell sx={{ borderBottom: 'none' }}>{t("Delivery Fee Area")}</TableCell>
                          <TableCell align='center' sx={{ borderBottom: 'none' }}>{t("branchManage_page.Status")}</TableCell>
                          <TableCell sx={{ borderBottom: 'none' }}></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {
                          controllers.rows?.map((item, index: number) => (
                            <TableRow key={index}>
                              <TableCell sx={{ borderBottom: 'none' }}>{controllers.handleCountIndex(index)}</TableCell>
                              <TableCell sx={{ borderBottom: 'none' }}>
                                <Avatar src={IMAGE_MERCHANT_URL + item?.image?.url} />
                              </TableCell>
                              <TableCell sx={{ borderBottom: 'none' }}>{i18n.language === EN_ACCEPT_LANGUAGE ? item?.nameEn : item?.nameLa}</TableCell>
                              {/* <TableCell sx={{ borderBottom: 'none' }}>{item.nameLa}</TableCell> */}
                              <TableCell align='center' sx={{ borderBottom: 'none' }}>{item.merchantNo}</TableCell>
                              <TableCell sx={{ borderBottom: 'none' }}>{item.village}</TableCell>
                              <TableCell sx={{ borderBottom: 'none' }}>{item.provice}</TableCell>
                              <TableCell sx={{ borderBottom: 'none' }}>{item.company}</TableCell>
                              <TableCell sx={{ borderBottom: 'none' }}>{item?.deliveryFee?.areaName}</TableCell>
                              <TableCell align='center' sx={{ borderBottom: 'none' }}>
                                <StatusChip status={item?.isActive} />
                              </TableCell>
                              <TableCell sx={{ borderBottom: 'none' }} align="right">
                                <IconButton size="large" color="inherit" onClick={(e: any) => controllers.handleOpenMenu(e, item.id)}>
                                  <MoreHorizIcon />
                                </IconButton>
                              </TableCell>
                            </TableRow>
                          ))
                        }
                      </TableBody>
                      {
                        controllers.isSearchNotFound && (
                          <TableSearchNotFound
                            searchValue={controllers.searchValue}
                            colSpan={controllers.TableHeader.length + 1}
                          />
                        )
                      }
                    </Table>
                  </TableContainer>
                  <Divider sx={{ mt: 1, mb: 1 }} />
                  <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                    <Pagination
                      color="primary"
                      count={controllers.countPagination}
                      page={controllers.currentPage}
                      onChange={controllers.handlePageChange}
                    />
                  </Box>
                </Box>
              </>
          }
          <Popover
            open={Boolean(controllers.openMenu)}
            anchorEl={controllers.openMenu}
            onClose={controllers.handleCloseMenu}
            anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            PaperProps={{
              sx: {
                p: 1,
                width: 140,
                '& .MuiMenuItem-root': {
                  px: 1,
                  typography: 'body2',
                  borderRadius: 0.75,
                },
              },
            }}
          >
            <MenuItem onClick={() => controllers.handleOpenEditForm()}>
              <EditIcon />
              &nbsp;&nbsp; {t("Edit")}
            </MenuItem>
            {/* <MenuItem onClick={() => controllers.handleOpenDeleteForm()}>
              <DeleteIcon />
              &nbsp;&nbsp; {t("Delete")}
            </MenuItem> */}
          </Popover>
          <ConfirmDialog
            open={controllers.openDeleteForm}
            title={t('Do you want to delete this Data ?')}
            loading={controllers.loadingDeleteButton}
            onCancel={controllers.handleCloseDeleteForm}
            onConfirm={controllers.handleDelete}
          />
        </Box>
      )}
    </>
  );
};
export default BranchManageView;
